"use client";
import { jsx as t } from "react/jsx-runtime";
import { cn as r } from "@deputy-ai/common";
import { cva as a } from "class-variance-authority";
import { Label as i } from "radix-ui";
const s = a(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);
function p({ className: e, ...o }) {
  return /* @__PURE__ */ t(
    i.Root,
    {
      className: r(s(), e),
      ...o
    }
  );
}
export {
  p as Label
};
